import React,{ Component } from 'react';
import { connect } from 'react-redux';
import { Camera } from 'react-feather';
import { last } from 'lodash';
import Actions from '../../../Actions';
import { getStatus, sanitizeData, cutString } from '../../../Utilities/Common';
import Confirm from '../Layout/Confirm';

class JobRow extends Component{
    render(){
        const { token, job, deleteJob, permissions: { can }, showLogs, edit, authUser: { role } } = this.props;
        let { vanity_id:id, id: real_id, location: { name: l1_name = '' }, sub_location: { name: l2_name = '' }, location_meta: l3_name, type, assignee, priority, status, problem, HS, user, created_at, comment, image, company } = sanitizeData(job);
        let location_name = l1_name;
        location_name += l2_name.length > 1 ? ` / ${l2_name}`:'';
        location_name += l3_name.length > 1 ? ` / ${l3_name}`:''; 
        const imageName = last(image.split("/"));
        const jobStatus = getStatus(status);
        return (
            <tr id={id} data-tip={`<span style="white-space: pre-line">Problem: ${problem} <br/><br/> Comment: ${comment}<br/><br/> Location: ${location_name} <br/><br/> Type: ${type.name} <br/><br/> Status: ${jobStatus.name} <br/><br/> Reported by: ${user.name} <br/><br/>Assigned To: ${assignee.name}</span>`}>
                <td>
                    <span onClick={() => edit(id)} className="btn-link" style={{cursor:"pointer"}}>
                        {id} 
                        {role === 3 && <span style={{color:"#808080",fontSize:10}}> / ({real_id})</span> }
                    </span>
                </td>
                <td>
                    {cutString(type.name)}
                </td>
                <td>
                    {HS === 1 ? <span style={{color:"red",fontWeight:"bold"}}>YES</span>: "No"}
                </td>
                <td>
                    <span className="btn btn-link" onClick={() => showLogs(id)}>{created_at}</span>
                </td>
                <td>
                    {cutString(location_name)}
                </td>
                <td>
                    <span className="btn" style={{width:"100%",backgroundColor: jobStatus.color, color:"#fff"}}>
                        {jobStatus.name}
                    </span>
                </td>
                <td>
                    {priority === 1 ? <span style={{color:"red",fontWeight:"bold"}}>URGENT</span>: "Medium"}</td><td>{imageName !== "default.jpg" && imageName !== "" ? <Camera size={18}/>:null}
                </td>
                <td>
                    {cutString(user.name)}
                </td>
                <td>
                    {cutString(assignee.name)}
                </td>
                {can('post','companies')?
                    <td>{company.name}</td>
                :null}
                {can('delete','jobs')?
                    <td>
                        <Confirm icon='Trash2' confirm={() => deleteJob(token,id)} />
                    </td>
                :null}
            </tr>
        );
    }
}
const mapStateToProps = (state) => ({
    token: state.auth.token,
    authUser: state.auth.user,
});
export default connect(mapStateToProps,Actions.jobs)(JobRow);


// WEBPACK FOOTER //
// ./src/Components/App/Jobs/JobRow.js